export enum Permission {
  BILLING_READ = 'Invoice and Billing: Read',
  MANAGE_USERS = 'Manage Users',
  MONITORING = 'Monitoring',
  NITEL_INTERNAL = 'Nitel Internal Only',
  NITEL_IQ_PARTICIPANT = 'Nitel IQ Participant',
  ORDERS = 'Orders',
  SERVICES = 'Services',
  TICKETING_READ = 'Ticketing: Read',
  TICKETING_WRITE = 'Ticketing: Write',
  MANAGED_SECURITY = 'Managed Security',
}
